/**
 * Get params from url, support hash
 * @author 学文
 * @param { string } key The params to get from url
 * @returns { string | null | undefined } Returns the params
 * @example
 *
 * getParamFromUrl('id') // http://leyopharm.com/job-detail?id=logistics -> 'logistics'
 */

const getParamFromUrl = (key: string) => {
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`)
  const search =
    window.location.hash.indexOf('?') !== -1 ? window.location.hash : window.location.search
  const paramData = search.split('?').length >= 2 && search.split('?')[1].match(reg)
  if (Array.isArray(paramData)) {
    return paramData[2]
  }
  return null
}

export default getParamFromUrl
